import { gql } from '@apollo/client';

export const GET_PEOPLE = gql`
  query GetPeople {
    getPeople {
      id
      name
      email
      phone
      preferredMethod
      birthday
      city
      country
      notes
      lastContacted
    }
  }
`;

export const CREATE_PERSON = gql`
  mutation CreatePerson($input: PersonInput!) {
    createPerson(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_PERSON = gql`
  mutation UpdatePerson($id: ID!, $input: PersonInput!) {
    updatePerson(id: $id, input: $input) {
      id
      name
    }
  }
`;

export const DELETE_PERSON = gql`
  mutation DeletePerson($id: ID!) {
    deletePerson(id: $id)
  }
`;
